export const version = '1.0.0';
export const buildDate = '2026-06-24T20:53:26.525Z';
